<div class="page-column">
    <app-logo />
    <div class="{{failedAppointments.length > 0 ? 'typo-h1 error-text' : 'typo-h1'}}">{{ title }}</div>
    @if(succeededAppointments.length > 0){    
    <div>
        <div class="body-text">{{ "courses.success.description" | transloco }}</div>
        <div class="appointment-list spacing-top-small">
            @for (dto of succeededAppointments; track dto.id) {
            <div class="body-text">{{dto.date}}</div>
            }
        </div>
        <div class="body-text spacing-top-small">{{ "courses.success.description2" | transloco }}</div>
    </div>
    }

    @if (failedAppointments.length > 0) {
    <div>
        <div class="body-text error-text">{{ "courses.success.descriptionError" | transloco }}</div>
        @for (dto of failedAppointments; track dto.id) {
        <div>
            <div class="appointment-list spacing-top-small">
                <div class="body-text">{{dto.date}}</div>
                <mat-error>{{ dto.error }}</mat-error>
            </div>
        </div>
        }
    </div>
    }

    <div class="actions">
        <app-text-button (click)="bookAppointment()" [text]="'courses.bookadditional' | transloco"
            colorVariant="primary" leadingIcon="calendar_month" type="rounded" />
        <app-text-button (click)="manageAppointments()" [text]="'booking.success.button.manageAppointments' | transloco"
            colorVariant="secondary" leadingIcon="edit_calendar" type="rounded" />
    </div>
</div>